export enum EWorkbookStatus {
  QUEUED = 'queued',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  IN_PROGRESS = 'inProgress',
  SUCCEEDED = 'succeeded'
}
